import React from "react";
import { Departments } from "components/Departments";

const DepartmentsComponent = () => {
    return <Departments />;
};

export default DepartmentsComponent;
